/*
  profile_page
  */
/**
* Special cases for profile page
*/


/************************************************
       Generate Years for Exp Year SelectBox
       *************************************************/
       var thisyear = new Date().getFullYear() - 10;
       var prfl_ccyear = $(".prfl_ccyear");

       for (i = thisyear; i < thisyear +21; i++) {
       	prfl_ccyear.append('<option>' + i + '</option>')
       }

       $("[class^=mob_profile-] [name=CBNumber], [class^=desk_profile-] [name=CBNumber]").change(function () {
       	$(".CreditCard_Number").val($(this).val());
       });

       $("[class^=mob_profile-] [type=checkbox], [class^=desk_profile-] [type=checkbox]").on("click", function() {
       	if ($(this).attr('value') === 'true')
       		$(this).attr('value', 'false');
       	else
       		$(this).attr('value', 'true');
       });

       if($(".WebloyaltyGroupCommunication").val()==="true") {
       	$(".WebloyaltyGroupCommunication").attr('checked', 'checked').attr('value', 'true');

       }
       
       if($(".ThirdPartiesCommunication").val()==="true"){
       	$(".ThirdPartiesCommunication").attr('checked', 'checked').attr('value', 'true');
       }